import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mFooter",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "mFooter-main"
  }, [_c('div', {
    staticClass: "logo btn",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@images/ui/wave-logo.svg"),
      "alt": "Wave"
    }
  }), _vm._m(0)]), _c('div', {
    staticClass: "shares"
  }, [_c('a', {
    staticClass: "shares-item hover",
    attrs: {
      "href": _vm.twitterUrl,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "aria-label": "Wave on X"
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm._v("WAVE"), _c('span', [_vm._v(".FUN")])]);
}];
export { render, staticRenderFns };